import { Resolver, gql } from '@apollo/client';

import axios from 'axios';
import _get from 'lodash/get';
import HttpStatus from 'http-status-codes';

import { handleProIngestion } from './helpers';

interface IngestProStatementInput {
    filename: string;
    proIngestionV2Url: string;
    statementUrl: string;
}

interface IngestProStatementV2Response {
    dashboard: ProIngestionDashboard;
    filename: string;
}

export const ingestProStatementV2: Resolver = async (
    obj: Record<string, unknown>,
    args: IngestProStatementInput,
    { cache },
): Promise<IngestProStatementV2Response | WrappedError> => {
    const { filename, statementUrl, proIngestionV2Url } = args;

    try {
        const response = await axios({
            method: 'post',
            url: proIngestionV2Url,
            data: {
                statement_url: statementUrl,
            },
        });

        const proIngestionStatusCode = _get(response, ['data', 'status_code']);

        if (response.status !== HttpStatus.OK) {
            throw new Error(`HTTP error: ${JSON.stringify(response)}`);
        } else if (proIngestionStatusCode !== HttpStatus.OK) {
            throw new Error(
                `PRO Ingestion V2 error: ${JSON.stringify(response.data)}`,
            );
        }
        let dashboard = _get(response, ['data', 'dashboard']);

        dashboard = handleProIngestion(
            HttpStatus.OK,
            dashboard,
            filename,
            cache,
        );

        return {
            dashboard,
            filename,
        };
    } catch (err) {
        return { error: err };
    }
};

export const INGEST_PRO_STATEMENT_V2 = gql`
    mutation IngestProStatementV2(
        $filename: String
        $proIngestionV2Url: String
        $statementUrl: String
    ) {
        ingestProStatementV2(
            filename: $filename
            proIngestionV2Url: $proIngestionV2Url
            statementUrl: $statementUrl
        ) @client
    }
`;
